var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetalhesCartao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 10,
    viewBox: "0 0 3 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.00195C0 5.33347 0.131696 5.65142 0.366117 5.88584C0.600537 6.12026 0.918479 6.25195 1.25 6.25195C1.58152 6.25195 1.89946 6.12026 2.13388 5.88584C2.3683 5.65142 2.5 5.33347 2.5 5.00195C2.5 4.67043 2.3683 4.35249 2.13388 4.11807C1.89946 3.88365 1.58152 3.75195 1.25 3.75195C0.918479 3.75195 0.600537 3.88365 0.366117 4.11807C0.131696 4.35249 0 4.67043 0 5.00195ZM0 1.25195C0 1.58347 0.131696 1.90142 0.366117 2.13584C0.600537 2.37026 0.918479 2.50195 1.25 2.50195C1.58152 2.50195 1.89946 2.37026 2.13388 2.13584C2.3683 1.90142 2.5 1.58347 2.5 1.25195C2.5 0.920433 2.3683 0.60249 2.13388 0.36807C1.89946 0.133649 1.58152 0.00195313 1.25 0.00195312C0.918479 0.00195313 0.600537 0.133649 0.366117 0.36807C0.131696 0.60249 0 0.920433 0 1.25195ZM0 8.75195C0 9.08347 0.131696 9.40142 0.366117 9.63584C0.600537 9.87026 0.918479 10.002 1.25 10.002C1.58152 10.002 1.89946 9.87026 2.13388 9.63584C2.3683 9.40142 2.5 9.08347 2.5 8.75195C2.5 8.42043 2.3683 8.10249 2.13388 7.86807C1.89946 7.63365 1.58152 7.50195 1.25 7.50195C0.918479 7.50195 0.600537 7.63365 0.366117 7.86807C0.131696 8.10249 0 8.42043 0 8.75195Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetalhesCartao);
export default __webpack_public_path__ + "static/media/detalhesCartao.fbe882c454dd69176a79c43861ca7977.svg";
export { ForwardRef as ReactComponent };